import { combineReducers } from 'redux';
import { reducer as accountPage } from './accountPage';
import info from './bookmakersSwitcherInfo.reducer';

const bookmakersSwitcherReducer = combineReducers({
    accountPage,
    info,
});

export default bookmakersSwitcherReducer;



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/bookmakersSwitcher.reducer.js